import React from "react";
import { useSelector } from "react-redux";
import LoginScreen from "../../components/LoginScreen/LoginScreen";
import AccessDenied from "../../components/common/AccessDenied";
import { REFERRAL_DASHBOARD_ROLES } from "../../pages/referral-dashboard/referralRoles";

// Gated on referral_role alone — user_type can be anything (Premium, Admin,
// Advisor, Marketing, ...). Every referral_role (SuperAdmin → SubBroker) gets
// the same dashboard; the data shown is scoped to roles below their own.
const ReferralRoute = ({ auth: { isAuthenticated }, children }) => {
  const userState = useSelector((store) => store.auth);
  const USER_DETAILS = userState?.user?.userDetails;

  if (typeof isAuthenticated === "undefined" || !userState?.user) {
    return <LoginScreen />;
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  const referralRole = USER_DETAILS?.referral_role;
  const canAccess = REFERRAL_DASHBOARD_ROLES.includes(referralRole);

  if (!canAccess) {
    return <AccessDenied />;
  }

  return children;
};

export default ReferralRoute;
